import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountSelector", "categoryFilter"]

  connect() {
    this.setupAccountSelector()
    this.setupCategoryFilter()
  }

  setupAccountSelector() {
    if (!this.hasAccountSelectorTarget) return

    this.accountSelectorTarget.addEventListener("change", (e) => {
      const accountId = e.target.value
      const monthId = this.element.dataset.monthId

      if (monthId) {
        window.location.href = `/accounts/${accountId}/months/${monthId}`
      }
    })
  }

  setupCategoryFilter() {
    if (!this.hasCategoryFilterTarget) return

    this.categoryFilterTarget.addEventListener('change', (e) => {
      const categoryId = e.target.value
      const checkedEntriesCard = document.querySelector('.card.mb-4')
      const checkedEntriesTable = checkedEntriesCard?.querySelector('table.table')

      if (!checkedEntriesTable) return

      const rows = checkedEntriesTable.querySelectorAll('tbody tr')

      if (categoryId === '') {
        rows.forEach(row => {
          row.style.opacity = '1'
          const amountCell = row.querySelector('td:nth-child(3)')
          if (amountCell) {
            amountCell.style.fontWeight = 'normal'
          }
        })
      } else {
        const klass = 'category-' + categoryId
        rows.forEach(row => {
          const hasCategory = row.querySelector('td.' + klass)
          row.style.opacity = hasCategory ? '1' : '0.15'
          const amountCell = row.querySelector('td:nth-child(3)')
          if (amountCell) {
            amountCell.style.fontWeight = hasCategory ? 'bold' : 'normal'
          }
        })
      }
    })
  }
}

